import { RadioGroup, RadioGroupProps } from "@mui/material";

export type SHRadioGroupProps = RadioGroupProps;
export const SHRadioGroup = (props: SHRadioGroupProps): JSX.Element => (
  <RadioGroup {...props} />
);
